import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';

export default function MicsEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [micsMessage, setMicsMessage] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);

    useEffect(() => {
        setMicsMessage(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
    }, [eventModuleRow]);

    function handleChange(e) {
        const newName = e.target.value;
        setMicsMessage(newName);
        updateEventModuleRow({
            name: newName,
            colour: bStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        updateEventModuleRow({
            name: micsMessage,
            colour: newStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    return (
        <div>
            <input type="text" style={{ width: '50%' }} className="form-control input-md"
                name="micsMessage" value={micsMessage}
                onChange={handleChange} placeholder="Enter Mics Message" />
            <SelectColourButton
                title="Select Colour"
                groupingSequence={eventModuleRow.event_grouping_seq}
                selectedColour={colourSelected}
                bStyle={bStyle} />
        </div>
    );
}
